<template>
<div>
<van-form style="margin-top:50px;" @submit="handleSubmit">
  <van-field
    v-model="username"
    name="Username"
    label="Kullanıcı Adı"
    placeholder="Kullanıcı Adı"
    :rules="[{ required: true, message: 'Kullanıcı Adı Gerekli' }]"
  />
  <van-field
    v-model="password"
    type="password"
    name="Password"
    label="Şifre"
    placeholder="Şifre"
    :rules="[{ required: true, message: 'Şifre Gerekli' }]"
  />
  <div style="margin: 16px;">
    <van-button block type="danger" native-type="submit">
      Giriş Yap
    </van-button>
  </div>
</van-form>
<div style="font-size:20px; text-align:center">{{error}}</div>
</div>
</template>

<script>
import { router } from '@/router';
//import { userService } from '../_services';

export default {
    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            returnUrl: '',
            error: '',
        }
    },
    created () {
        this.returnUrl = this.$route.query.returnUrl || '/';
    },
    methods: {
        handleSubmit (e) {

            this.submitted = true;
            const { username, password } = this;

            if (!(username && password)) {
                return;
            }
            this.loading = true;
            this.$helper.login(username, password)
                .then(res => {

                  if (res.status){
                      this.$store.dispatch("source",res.data).then(ok=>{
                        router.push(this.returnUrl)
                      })

                    }
                    else{
                        this.error ='Bilgiler hatalı ya da yetkisiz kullanıcı';
                        this.loading = false
                      }
                })
                .catch (err => {
                  this.error = err;
                this.loading = false;})
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/LoginPage.vue